export default __webpack_public_path__ + "static/solution-interact-3a1b03def9bf6e5a79631978ac1042c6.png";